export type OpeningHour = {
	day: string;
	hours: string;
};

export const openingHours: OpeningHour[] = [
	{ day: "lundi", hours: "08:30-16:30" },
	{ day: "mardi", hours: "08:30-16:30" },
	{ day: "mercredi", hours: "08:30-16:30" },
	{ day: "jeudi", hours: "08:30-16:30" },
	{ day: "vendredi", hours: "08:30-16:30" },
];
